"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CowSwapper = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const types_1 = require("@shapeshiftoss/types");
const api_1 = require("../../api");
const cowApprovalNeeded_1 = require("./cowApprovalNeeded/cowApprovalNeeded");
const cowApprove_1 = require("./cowApprove/cowApprove");
const cowBuildTrade_1 = require("./cowBuildTrade/cowBuildTrade");
const cowExecuteTrade_1 = require("./cowExecuteTrade/cowExecuteTrade");
const cowGetTradeTxs_1 = require("./cowGetTradeTxs/cowGetTradeTxs");
const getCowSwapTradeQuote_1 = require("./getCowSwapTradeQuote/getCowSwapTradeQuote");
const blacklist_1 = require("./utils/blacklist");
const helpers_1 = require("./utils/helpers/helpers");
class CowSwapper {
    constructor(deps) {
        this.name = api_1.SwapperName.CowSwap;
        this.deps = deps;
    }
    getType() {
        return api_1.SwapperType.CowSwap;
    }
    async buildTrade(args) {
        return (0, cowBuildTrade_1.cowBuildTrade)(this.deps, args);
    }
    async getTradeQuote(input) {
        return (0, getCowSwapTradeQuote_1.getCowSwapTradeQuote)(this.deps, input);
    }
    async getUsdRate(input) {
        return (0, helpers_1.getUsdRate)(this.deps, input);
    }
    async executeTrade(args) {
        return (0, cowExecuteTrade_1.cowExecuteTrade)(this.deps, args);
    }
    async approvalNeeded(args) {
        return (0, cowApprovalNeeded_1.cowApprovalNeeded)(this.deps, args);
    }
    async approveInfinite(args) {
        return (0, cowApprove_1.cowApproveInfinite)(this.deps, args);
    }
    async approveAmount(args) {
        return (0, cowApprove_1.cowApproveAmount)(this.deps, args);
    }
    filterBuyAssetsBySellAssetId(args) {
        const { assetIds = [], sellAssetId } = args;
        if ((0, caip_1.fromAssetId)(sellAssetId).assetNamespace !== 'erc20' ||
            blacklist_1.COWSWAP_UNSUPPORTED_ASSETS.includes(sellAssetId))
            return [];
        return assetIds.filter((id) => id !== sellAssetId &&
            (0, caip_1.fromAssetId)(id).chainId === types_1.KnownChainIds.EthereumMainnet &&
            !blacklist_1.COWSWAP_UNSUPPORTED_ASSETS.includes(id));
    }
    filterAssetIdsBySellable(assetIds) {
        return assetIds.filter((id) => (0, caip_1.fromAssetId)(id).assetNamespace === 'erc20' && !blacklist_1.COWSWAP_UNSUPPORTED_ASSETS.includes(id));
    }
    async getTradeTxs(args) {
        return (0, cowGetTradeTxs_1.cowGetTradeTxs)(this.deps, args);
    }
}
exports.CowSwapper = CowSwapper;
__exportStar(require("./utils"), exports);
__exportStar(require("./types"), exports);
